// Filename - pages/Events.js

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import BulkFileUpload from "./bulkFileUpload";
import UpdateStatus from "./UpdateStatus";

import "./FileDropZone.css";
import { ReactDialogBox } from "react-js-dialog-box";
import { Card, Nav, Button, Row, Col } from "react-bootstrap";
export const BulkUpload = (onFileUpload) => {
  const { data } = useSelector((state) => state.loginReducer);
  const dispatch = useDispatch();
  const [isActive, setActive] = useState("#BulkUpdat");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const handleClick = (e, p) => {
    setActive(e);
    console.log(isActive);
  };

  return (
    <>
      <Card
        style={{
          height: "94px",
          width: "100%",
          backgroundColor: "#17234D",
          borderRadius: "0px",
        }}
      >
        <Card.Body>
          <Card.Title
            style={{
              color: "#fff",
              fontFamily: "Roboto-Regular",
              fontSize: "25px",
            }}
          >
            Bulk Upload
          </Card.Title>
          <Card.Text
            style={{
              color: "#fff",
              fontFamily: "Roboto-Light",
              fontSize: "15px",
            }}
          >
            Upload XLS file
          </Card.Text>
        </Card.Body>
      </Card>
      <Card
        style={{ boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", margin: "30px" }}
      >
        <Card.Header
          style={{
            padding: "0px 0px 0px 20px",
            marginTop: "10px",
            bottom: "20px",
            backgroundColor: "white",
          }}
        >
          <Nav
            variant="underline"
            activeKey={isActive}
            onSelect={(selectedKey) => {
              setActive(selectedKey);
              console.log(`selected ${selectedKey}`);
            }}
          >
            <Nav.Item>
              <Nav.Link
                href="#BulkUpdat"
                eventKey="#BulkUpdat"
                onClick={handleClick}
                style={{ fontFamily: "Roboto-Regular", fontSize: "17px" }}
              >
                Bulk Update
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                href="#UploadStatus"
                eventKey="#UploadStatus"
                onClick={handleClick}
                style={{ fontFamily: "Roboto-Regular", fontSize: "17px" }}
              >
                Upload Status
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Card.Header>

        <Card.Body
          style={{ maxHeight: "70vh", overflowY: "auto", paddingBottom: 30 }}
        >
          <>
            {isActive == "#BulkUpdat" && <BulkFileUpload />}
            {isActive == "#UploadStatus" && <UpdateStatus />}
          </>
        </Card.Body>
      </Card>
    </>
  );
};
